import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SK_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SK_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SK_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SK_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.603 6.03l.498-.053-.048-.447H5.877l-.032.467.5.033-.5-.033h0v.016l-.004.046-.011.176a124.712 124.712 0 00-.142 2.688c-.065 1.54-.108 3.342.004 4.184.219 1.642 1.219 5.33 5.087 7l.202.087.2-.09c3.675-1.642 4.904-4.95 5.187-6.995.143-1.031.07-2.836-.03-4.336a81.213 81.213 0 00-.231-2.737l-.005-.043-.001-.012v-.003h0l-.498.052z",
      fill: "#E31D1C",
      stroke: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SK_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 5,
      y: 5,
      width: 12,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.603 6.03l.498-.053-.048-.447H5.877l-.032.467.5.033-.5-.033h0v.016l-.004.046-.011.176a124.712 124.712 0 00-.142 2.688c-.065 1.54-.108 3.342.004 4.184.219 1.642 1.219 5.33 5.087 7l.202.087.2-.09c3.675-1.642 4.904-4.95 5.187-6.995.143-1.031.07-2.836-.03-4.336a81.213 81.213 0 00-.231-2.737l-.005-.043-.001-.012v-.003h0l-.498.052z",
        fill: "#fff",
        stroke: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SK_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.256 6.59s.207.314.3.796c.092.48.108 1.324.108 1.324l-1.96-.242v1.486l2.003-.255-.032 1.41s-.6.062-1.09 0c-.492-.063-1.46-.323-1.46-.323v1.7s.983-.314 1.46-.386c.475-.073 1.09 0 1.09 0v2.088h.813V12.1s.889-.078 1.419.006 1.033.38 1.033.38v-1.7s-.51.254-.99.317-1.462.005-1.462.005l.033-1.41s.665-.068 1.038-.018c.373.051.84.274.84.274V8.468s-.455.248-.813.293c-.359.045-1.11-.051-1.11-.051s.014-.87.091-1.294c.077-.423.295-.826.295-.826h-1.606z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.896 16.245s.44-.943 1.155-1.122c.715-.18 1.465.56 1.465.56s.458-1.495 1.574-1.495 1.508 1.496 1.508 1.496.476-.561 1.16-.561c.686 0 1.32 1.122 1.32 1.122s-2.045 3.714-4.09 3.714c-2.046 0-4.092-3.714-4.092-3.714z",
      fill: "#2E42A5"
    }
  ))))
), a = t;
export {
  a as default
};
